import { type ModuleFederation, getInstance } from '@module-federation/runtime';

let mfInstance: ModuleFederation | null = null;

const isProd =
  import.meta.env.PROD &&
  !window.location.hostname.includes('-qa.') &&
  !window.location.hostname.includes('staging.');

// TODO: Setup environment variables for this (currently there are none configured for this project)
const SSO_UI_URL = isProd
  ? 'https://up-user-management.360platform.inmarket.com'
  : 'https://dev-up-user-management.360platform.inmarket.com';

const loadUserManagementRemote = (remoteName: string) => {
  if (!mfInstance) {
    mfInstance = getInstance();
    if (!mfInstance) throw new Error('MF instance not found');

    mfInstance.registerRemotes([
      {
        name: 'user_management_frontend',
        entry: `${SSO_UI_URL}/remoteEntry.js`,
      },
    ]);
  }

  return mfInstance.loadRemote(`user_management_frontend/${remoteName}`);
};

export default loadUserManagementRemote;
